<template>
  <tbody>
    <tr v-for="(missPerson, index) in missedPeople" :key="index">
      <th scope="row">{{ index + 1 }}</th>

      <td>
        {{ missPerson.person_last_name }}
        {{ missPerson.person_first_name }}
      </td>
      <td>
        <!-- {{
          new Date()
            .toISOString()
            .split("T")[0]
            .split("-")
            .reverse()
            .join("-")
        }} -->
      </td>
      <td></td>
      <td></td>

      <td v-if="missPerson.is_on_holidays != null">
        {{ missPerson.is_on_holidays }}
      </td>
    </tr>
  </tbody>
  <!-- </table> -->
</template>

<script>
export default {
  props: ["missedPeople"],
};
</script>
